import { Socket, io } from "socket.io-client"

import { seconds } from "@/3514/utils"
import { EStorageServiceType, SessionStorageServiceKeys, StorageService } from "@/services"

import type {
    ICoachingChatSocketClientEvents as IClientEvents,
    ICoachingChatSocketServerEvents as IServerEvents
} from "../../types"

type TCoachingChatSocket = Socket<IServerEvents, IClientEvents>

const storageService: StorageService = new StorageService(EStorageServiceType.Session)

const authToken: string = storageService.getItem(SessionStorageServiceKeys.ChatSocketToken()) ?? String("")

const coachingChatSocket: TCoachingChatSocket = io(window.location.origin, {
    path: "/ws/socket.io/",
    transports: ["websocket", "polling"],
    autoConnect: false,
    rejectUnauthorized: true,
    secure: true,
    reconnection: true,
    reconnectionAttempts: 10,
    reconnectionDelay: seconds(1),
    reconnectionDelayMax: seconds(10),
    randomizationFactor: 0.5,
    auth: { token: authToken }
})

export { coachingChatSocket }
export type { TCoachingChatSocket }
